// extracted by mini-css-extract-plugin
export default {"errorLoader__title":"ErrorLoader_errorLoader__title__Yq2ZH","errorLoader__button":"ErrorLoader_errorLoader__button__QtWFM"};